import {
  SET_ACTIVE_USER,
  LOGOUT_USER
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case LOGOUT_USER:
      return {};

    case SET_ACTIVE_USER:
      return action.payload;

    default:
      return state;
  }
}